// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ba9083df","423":"05dfccac","563":"2f5f9987","564":"40c5c853","798":"24563811"}[chunkId] + ".chunk.js";
};